// extracted by mini-css-extract-plugin
export default {"root":"ContentContainer_root__W-qzQ"};